import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLayoutBottom"><Path d="M21 15.5C21 16.8807 19.8807 18 18.5 18H5.5C4.11929 18 3 16.8807 3 15.5V5.5C3 4.11929 4.11929 3 5.5 3H18.5C19.8807 3 21 4.11929 21 5.5V15.5Z" fill="currentColor"/><Path d="M21 20.5C21 20.7761 20.7761 21 20.5 21H3.5C3.22386 21 3 20.7761 3 20.5C3 20.2239 3.22386 20 3.5 20H20.5C20.7761 20 21 20.2239 21 20.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutBottom;
